var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "benefits-section" },
    [
      _c(
        "el-row",
        {
          staticClass: "benefits-section-inner",
          attrs: { type: "flex", align: "middle" }
        },
        [
          _c("el-col", { attrs: { xs: 24, sm: 12 } }, [
            _c("h2", { staticClass: "section-title" }, [
              _vm._v("Platform Benefits for Agents")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "benefit-item" }, [
              _c("h3", { staticClass: "benefit-item-title" }, [
                _vm._v("Increased Visibility:")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "benefit-item-description" }, [
                _vm._v(
                  "Our platform is tailored to highlight new projects, giving you access to a growing pool of buyers interested in off-the-plan properties."
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "benefit-item" }, [
              _c("h3", { staticClass: "benefit-item-title" }, [
                _vm._v("High-Quality Leads:")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "benefit-item-description" }, [
                _vm._v(
                  "With customizable search filters, buyers are matched with the properties that best meet their criteria, ensuring your listings reach the most relevant audience."
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "benefit-item" }, [
              _c("h3", { staticClass: "benefit-item-title" }, [
                _vm._v("Comprehensive Data Insights:")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "benefit-item-description" }, [
                _vm._v(
                  "Every listing includes detailed information, including rental appraisals and specifications guides, helping you deliver a seamless, informative buying experience."
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            {
              staticClass: "image-container-wrapper",
              attrs: { xs: 24, sm: 12 }
            },
            [
              _c("div", { staticClass: "image-container" }, [
                _c("img", {
                  staticClass: "feature-image",
                  attrs: {
                    src: require("../../../assets/agent-section-3-page-background.png"),
                    alt: "Blueprint review process"
                  }
                })
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55e2251f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55e2251f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/agentRegistration/agentRegistrationSection3.vue
// module id = null
// module chunks = 